import React from 'react';

/**
 * DummyObject component - renders a cylinder or plane in the 3D scene
 */
function DummyObject({ type, color, cylinder, plane }) {
  if (type === 'cylinder') {
    // Cylinder is created along Y-axis by default, rotate to align with Z-axis
    // Position at origin (0,0,0) so midpoint is at origin
    return (
      <mesh position={[0, 0, 0]} rotation={[Math.PI / 2, 0, 0]}>
        <cylinderGeometry args={[cylinder.radius, cylinder.radius, cylinder.height, 32]} />
        <meshStandardMaterial color={color} transparent opacity={0.8} />
      </mesh>
    );
  }

  if (type === 'plane') {
    // Box centered at origin by default
    return (
      <mesh position={[0, 0, 0]}>
        <boxGeometry args={[plane.width, plane.height, plane.thickness]} />
        <meshStandardMaterial color={color} transparent opacity={0.8} />
      </mesh>
    );
  }

  return null;
}

export default DummyObject;
